import { extend } from 'sk-ui/lib/utils/util.js'
import { action } from 'sky-engine/api/index'

import toBeDeliveryDeployProjectDetail from './metaData/toBeDeliveryDeployProjectDetail'

import ddFormForTemplate from '../../modules/deliveryDeployMng/metaData/ddFormForTemplate'

import { DELIVERY_PROJECT_MNG } from '@/api/apiModules'
import { updateFlowStatus } from '@/api/deliveryProject'
import { getIndustryList } from '@/api/setting'
export default {
  CreateDdProjectFromTemOnToBe({ commit }, params) {
    const ptFormCopy = extend(true, {}, ddFormForTemplate)
    ptFormCopy.breadcrumb = {
      title: null,
      action: '',
      class: ''
    }
    ptFormCopy.callBackAction = 'CreateNewDdProjectFromTemSuccessBack'
    ptFormCopy.view.content.unshift({
      $id: 'templateProjectIdLabel',
      $type: 'sky-relation-option',
      label: '项目模版',
      $el: { disabled: false, multiple: false },
      actions: {
        nativeOn: {
          click: 'UmRelationDdTemplateProject'
        }
      },
      rules: [{ notEmpty: { message: '模版项目不能为空' } }]
    })

    getIndustryList({}).then(res => {
      var changeList = []
      for (const iterator of res.data.content.itemArr) {
        if (iterator.industryCode === 'QY') {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            label: iterator.industryName
          })
        }
      }
      ptFormCopy.view.content[1].$options = changeList

      action(DELIVERY_PROJECT_MNG, 'detail', {
        id: params.row.id
      }).then(result => {
        var props = {
          params: {},
          industryId: result.data.content.industryId,
          projectName: result.data.content.projectName,
          customer: result.data.content.customer,
          salesIdLabel: result.data.content.salesIdLabel,
          presalesIdLabel: result.data.content.presalesIdLabel,
          salesLeaderLabelList: result.data.content.salesLeaderLabelList,
          postsalesIdLabelList: result.data.content.postsalesIdLabelList,
          contractNo: result.data.content.contractNo,
          productName: result.data.content.productName,
          productList: result.data.content.productList,
          startTime: result.data.content.startTime
        }

        props.params = {
          id: params.row.id,
          flowStatus: 'MDR_DEPLOY_NETWORK_INFO'
        }

        this.dispatch('OpenFullDialog', {
          metaData: ptFormCopy,
          props
        })
      })
    })
  },
  CreateNewDdProject({ commit }, params) {
    const ptFormCopy = extend(true, {}, ddFormForTemplate)
    ptFormCopy.breadcrumb = {
      title: null,
      action: '',
      class: ''
    }
    ptFormCopy.callBackAction = 'CreateNewDdProjectSuccessBack'
    getIndustryList({}).then(res => {
      var changeList = []
      for (const iterator of res.data.content.itemArr) {
        if (iterator.industryCode === 'QY') {
          changeList.push({
            id: iterator.id,
            value: iterator.id,
            label: iterator.industryName
          })
        }
      }
      ptFormCopy.view.content[0].$options = changeList

      action(DELIVERY_PROJECT_MNG, 'detail', {
        id: params.row.id
      }).then(result => {
        var props = {
          params: {},
          industryId: result.data.content.industryId,
          projectName: result.data.content.projectName,
          customer: result.data.content.customer,
          salesIdLabel: result.data.content.salesIdLabel,
          presalesIdLabel: result.data.content.presalesIdLabel,
          salesLeaderLabelList: result.data.content.salesLeaderLabelList,
          postsalesIdLabelList: result.data.content.postsalesIdLabelList,
          contractNo: result.data.content.contractNo,
          productName: result.data.content.productName,
          productList: result.data.content.productList,
          startTime: result.data.content.startTime
        }

        props.params = {
          id: params.row.id,
          flowStatus: 'MDR_DEPLOY_PROJECT_INIT'
        }
        this.dispatch('OpenFullDialog', {
          metaData: ptFormCopy,
          props
        })
      })
    })
  },
  CreateNewDdProjectFromTemSuccessBack({ commit }, params) {
    const props = {
      params: {
        projectId: params.response.data.content,
        flowStatus: 'MDR_DEPLOY_NETWORK_INFO',
        createBytmp: true,
        industryId: params.requestDatas.industryId
      }
    }
    updateFlowStatus({
      projectId: params.response.data.content,
      flowStatus: 'MDR_DEPLOY_NETWORK_INFO'
    }).then(res => {})
    const toBeDeliveryDeployProjectDetailCopy = extend(true, {}, toBeDeliveryDeployProjectDetail)
    toBeDeliveryDeployProjectDetailCopy.breadcrumb = {
      title: params.requestDatas.customer,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: toBeDeliveryDeployProjectDetailCopy,
      props
    })
  },
  CreateNewDdProjectSuccessBack({ commit }, params) {
    const props = {
      params: {
        projectId: params.response.data.content,
        flowStatus: 'MDR_DEPLOY_JOB_PC_INFO',
        createBytmp: true,
        industryId: params.requestDatas.industryId
      }
    }
    updateFlowStatus({
      projectId: params.response.data.content,
      flowStatus: 'MDR_DEPLOY_JOB_PC_INFO'
    }).then(res => {})
    const toBeDeliveryDeployProjectDetailCopy = extend(true, {}, toBeDeliveryDeployProjectDetail)
    toBeDeliveryDeployProjectDetailCopy.breadcrumb = {
      title: params.requestDatas.customer,
      action: '',
      class: ''
    }
    this.dispatch('OpenFullDialog', {
      metaData: toBeDeliveryDeployProjectDetailCopy,
      props
    })
  }
}
